<template>
  <div class="page">
    <header class="hero">
      <div class="hero-media">
        <img src="/back_images.jpg" alt="伊川厂房外景背景图" class="hero-bg-image" />
        <div class="hero-overlay"></div>
      </div>

      <div class="container hero-content">
        <div class="hero-badge">伊川县 · 标准工业厂房招租</div>
        <h1>伊川标准工业厂房出租</h1>
        <p class="hero-subtitle">通用制造业适用｜交通便捷｜配套完善｜可实地考察</p>

        <div class="hero-tags">
          <span>总面积 5600㎡</span>
          <span>生产区 2000㎡</span>
          <span>层高 9 米</span>
          <span>承重 5 吨/㎡</span>
        </div>

        <div class="hero-actions">
          <a :href="`tel:${phone}`" class="btn btn-primary">立即电话咨询</a>
          <a href="#details" class="btn btn-secondary">查看厂房详情</a>
        </div>
      </div>
    </header>

    <main>
      <section class="section quick-info">
        <div class="container grid grid-4">
          <div class="info-card">
            <div class="info-label">适用行业</div>
            <div class="info-value">通用制造业</div>
          </div>
          <div class="info-card">
            <div class="info-label">位置</div>
            <div class="info-value">伊川县高山镇贾村</div>
          </div>
          <div class="info-card">
            <div class="info-label">租金参考</div>
            <div class="info-value">5元/㎡/月</div>
          </div>
          <div class="info-card highlight">
            <div class="info-label">联系电话</div>
            <div class="info-value">{{ displayPhone }}</div>
          </div>
        </div>
      </section>

      <section class="section intro-media-section">
        <div class="container intro-media-grid">
          <div class="intro-copy card-surface">
            <span class="section-kicker">厂房概览</span>
            <h2>标准工业厂房，兼顾生产、办公与运输便利</h2>
            <p>
              厂房位于伊川县高山镇贾村，东邻伊川新伊高速进出口约 3 公里，西距白杨新伊出站口约 4 公里，
              原材料运入与成品运出更高效，适合机械加工、零部件生产及各类通用制造业企业入驻。
            </p>
            <p>
              页面中的图片和视频已预留为真实展示区，你现在只需要把文件放在 <strong>public</strong> 目录下，
              就可以直接在网页中正常显示，并且在电脑和手机上都能保持自适应。
            </p>
          </div>

          <div class="media-stack">
            <div class="media-card panoramic-card">
              <img src="/Panorama.jpg" alt="厂房全景展示" class="fit-media" />
            </div>
            <div class="media-card video-card">
              <video class="fit-media" controls playsinline preload="metadata">
                <source src="/forRent.mp4" type="video/mp4" />
                您的浏览器暂不支持视频播放。
              </video>
            </div>
          </div>
        </div>
      </section>

      <section id="details" class="section">
        <div class="container two-col">
          <div>
            <div class="section-title-wrap">
              <span class="section-kicker">厂房详情</span>
              <h2>标准工业建筑，适合机械加工与零部件生产</h2>
            </div>
            <p class="lead">
              厂房整体为标准工业建筑，总面积 5600 平方米，其中生产区面积 2000 平方米，层高 9 米，
              牛腿设计承重 5 吨/平方米，可满足各类机床、生产线等重型设备安装需求。
            </p>

            <div class="feature-list">
              <div v-for="item in features" :key="item.title" class="feature-item">
                <div class="feature-icon">✓</div>
                <div>
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.desc }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="side-panel">
            <div class="panel-card">
              <h3>核心参数</h3>
              <ul class="spec-list">
                <li><span>总面积</span><strong>5600 平方米</strong></li>
                <li><span>生产区面积</span><strong>2000 平方米</strong></li>
                <li><span>办公配套</span><strong>600 平方米</strong></li>
                <li><span>层高</span><strong>9 米</strong></li>
                <li><span>设计承重</span><strong>5 吨/平方米</strong></li>
                <li><span>变压器</span><strong>315 型</strong></li>
                <li><span>支付方式</span><strong>月付 / 季付 / 年付</strong></li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section class="section section-soft">
        <div class="container">
          <div class="section-title-wrap center">
            <span class="section-kicker">优势亮点</span>
            <h2>不只是有厂房，更重视企业落地后的生产便利</h2>
          </div>

          <div class="grid grid-3">
            <article class="adv-card" v-for="adv in advantages" :key="adv.title">
              <div class="adv-number">{{ adv.no }}</div>
              <h3>{{ adv.title }}</h3>
              <p>{{ adv.desc }}</p>
            </article>
          </div>
        </div>
      </section>

      <section class="section gallery-section">
        <div class="container">
          <div class="section-title-wrap center">
            <span class="section-kicker">实景展示</span>
            <h2>外景、全景与视频多维展示</h2>
            <p>图片使用原比例展示，视频采用固定圆角容器，确保在不同设备下都不变形。</p>
          </div>

          <div class="showcase-grid">
            <div class="showcase-card showcase-image-main">
              <img src="/back_images.jpg" alt="厂房外景" class="fit-media" />
            </div>
            <div class="showcase-card showcase-image-side">
              <img src="/Panorama.jpg" alt="厂房全景" class="fit-media" />
            </div>
            <div class="showcase-card showcase-video-wide">
              <video class="fit-media" controls playsinline preload="metadata">
                <source src="/forRent.mp4" type="video/mp4" />
                您的浏览器暂不支持视频播放。
              </video>
            </div>
          </div>
        </div>
      </section>

      <section class="section">
        <div class="container rent-box">
          <div>
            <span class="section-kicker">租赁说明</span>
            <h2>付款灵活，欢迎实地考察洽谈</h2>
            <p>
              租赁价格参考为 <strong>5 元/平方米/月</strong>，支持月付、季付或年付，年付可优惠。
              适合机械加工及零部件生产等符合产业规划的企业入驻，租满后可优先续租。
            </p>
          </div>
          <div class="rent-cta">
            <a :href="`tel:${phone}`" class="btn btn-primary btn-lg">拨打电话：{{ displayPhone }}</a>
            <p>欢迎联系咨询厂房详情、配套情况与实地考察安排。</p>
          </div>
        </div>
      </section>

      <section class="section contact-section">
        <div class="container contact-card">
          <div>
            <span class="section-kicker">联系我们</span>
            <h2>伊川厂房出租，欢迎来电咨询</h2>
            <p>
              如需了解伊川县厂房出租、标准工业厂房、独立办公配套、交通情况等信息，
              可直接电话联系，我们将提供积极服务，助力企业快速投产及运营。
            </p>
          </div>
          <div class="contact-side">
            <div class="contact-phone">{{ displayPhone }}</div>
            <a :href="`tel:${phone}`" class="btn btn-dark">一键拨号</a>
            <div class="contact-address">地址：伊川县高山镇贾村</div>
          </div>
        </div>
      </section>
    </main>

    <footer class="footer">
      <div class="container footer-inner">
        <div>
          <strong>伊川标准工业厂房出租</strong>
          <p>适用于制造业、机械加工、零部件生产等企业。</p>
        </div>
        <div class="footer-links">
          <a href="#details">厂房详情</a>
          <a :href="`tel:${phone}`">电话咨询</a>
        </div>
      </div>
    </footer>

    <a :href="`tel:${phone}`" class="mobile-call">电话咨询</a>
  </div>
</template>

<script setup>
const phone = '15036983576'
const displayPhone = '150 3698 3576'

const features = [
  {
    title: '标准工业建筑',
    desc: '总面积 5600 平方米，整体规划清晰，适合各类通用制造业企业入驻。',
  },
  {
    title: '重型设备友好',
    desc: '生产区面积 2000 平方米，层高 9 米，牛腿设计承重 5 吨/平方米，可满足机床、生产线等设备安装需求。',
  },
  {
    title: '办公与宿舍配套',
    desc: '配套办公区 600 平方米，包含独立办公及工人宿舍，使用更方便。',
  },
  {
    title: '基础设施完善',
    desc: '现有 315 型变压器，水电设施齐全，厂区已安装监控系统。',
  },
]

const advantages = [
  {
    no: '01',
    title: '交通便捷',
    desc: '东邻伊川新伊高速进出口约 3 公里，西距白杨新伊出站口约 4 公里，方便货运运输。',
  },
  {
    no: '02',
    title: '综合成本更低',
    desc: '原材料运入与成品运出效率较高，有助于降低物流与落地运营成本。',
  },
  {
    no: '03',
    title: '用工相对便利',
    desc: '当地企业相对较少，劳动力资源较多，职工相对更好招聘。',
  },
]
</script>

<style scoped>
:global(*) {
  box-sizing: border-box;
}

:global(html) {
  scroll-behavior: smooth;
}

:global(body) {
  margin: 0;
  font-family: 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Arial, sans-serif;
  background: #f6f8fb;
  color: #1f2937;
}

:global(a) {
  text-decoration: none;
}

:global(img),
:global(video) {
  display: block;
  max-width: 100%;
}

.page {
  min-height: 100vh;
}

.container {
  width: min(1180px, calc(100% - 32px));
  margin: 0 auto;
}

.section {
  padding: 72px 0;
}

.section-soft {
  background: linear-gradient(180deg, #f9fbff 0%, #eef5ff 100%);
}

.card-surface {
  background: rgba(255, 255, 255, 0.88);
  border: 1px solid rgba(255, 255, 255, 0.72);
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.08);
  border-radius: 28px;
  backdrop-filter: blur(12px);
}

.fit-media {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  background: #eef2f7;
}

.hero {
  position: relative;
  overflow: hidden;
  min-height: 86vh;
  display: flex;
  align-items: center;
  color: #fff;
}

.hero-media {
  position: absolute;
  inset: 0;
}

.hero-bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(135deg, rgba(10, 26, 47, 0.86), rgba(12, 64, 120, 0.68)),
    radial-gradient(circle at 20% 20%, rgba(255, 255, 255, 0.14), transparent 28%),
    radial-gradient(circle at 80% 30%, rgba(126, 214, 255, 0.18), transparent 22%),
    radial-gradient(circle at 60% 80%, rgba(255, 255, 255, 0.08), transparent 26%);
}

.hero-content {
  position: relative;
  z-index: 1;
  padding: 88px 0;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  padding: 10px 16px;
  border: 1px solid rgba(255, 255, 255, 0.22);
  background: rgba(255, 255, 255, 0.12);
  border-radius: 999px;
  font-size: 14px;
  margin-bottom: 20px;
  backdrop-filter: blur(8px);
}

.hero h1 {
  margin: 0;
  max-width: 820px;
  font-size: clamp(34px, 6vw, 68px);
  line-height: 1.08;
  letter-spacing: 1px;
}

.hero-subtitle {
  max-width: 760px;
  margin: 20px 0 0;
  font-size: clamp(16px, 2.2vw, 22px);
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.9);
}

.hero-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 28px;
}

.hero-tags span {
  padding: 10px 14px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.14);
  backdrop-filter: blur(6px);
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 34px;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 0 22px;
  border-radius: 14px;
  font-weight: 700;
  transition: transform .2s ease, box-shadow .2s ease, background .2s ease;
}

.btn:hover {
  transform: translateY(-2px);
}

.btn-primary {
  color: #fff;
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  box-shadow: 0 14px 30px rgba(37, 99, 235, 0.28);
}

.btn-secondary {
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.1);
}

.btn-dark {
  color: #fff;
  background: #111827;
}

.btn-lg {
  min-height: 56px;
  padding: 0 26px;
  font-size: 16px;
}

.grid {
  display: grid;
  gap: 22px;
}

.grid-4 {
  grid-template-columns: repeat(4, 1fr);
}

.grid-3 {
  grid-template-columns: repeat(3, 1fr);
}

.quick-info {
  margin-top: -52px;
  position: relative;
  z-index: 4;
}

.info-card {
  background: rgba(255, 255, 255, 0.82);
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.08);
  backdrop-filter: blur(12px);
  border-radius: 24px;
  padding: 24px;
}

.info-card.highlight {
  background: linear-gradient(135deg, #eff6ff, #dbeafe);
}

.info-label {
  font-size: 14px;
  color: #64748b;
  margin-bottom: 10px;
}

.info-value {
  font-size: 24px;
  font-weight: 800;
  color: #0f172a;
}

.intro-media-section {
  padding-top: 36px;
}

.intro-media-grid {
  display: grid;
  grid-template-columns: 1fr 1.08fr;
  gap: 24px;
  align-items: stretch;
}

.intro-copy {
  padding: 30px;
}

.intro-copy h2 {
  margin: 0 0 16px;
  font-size: clamp(28px, 4vw, 42px);
  line-height: 1.2;
  color: #0f172a;
}

.intro-copy p {
  margin: 0 0 14px;
  line-height: 1.9;
  color: #475569;
}

.media-stack {
  display: grid;
  gap: 18px;
}

.media-card,
.showcase-card {
  overflow: hidden;
  border-radius: 28px;
  background: #fff;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);
}

.panoramic-card {
  min-height: 280px;
  padding: 14px;
}

.video-card {
  min-height: 320px;
  padding: 14px;
}

.two-col {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(320px, 0.8fr);
  gap: 28px;
  align-items: start;
}

.section-title-wrap {
  margin-bottom: 26px;
}

.section-title-wrap.center {
  text-align: center;
}

.section-kicker {
  display: inline-block;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 1.4px;
  color: #2563eb;
  text-transform: uppercase;
  margin-bottom: 12px;
}

.lead {
  margin: 0 0 22px;
  font-size: 17px;
  line-height: 1.95;
  color: #475569;
}

.feature-list {
  display: grid;
  gap: 18px;
}

.feature-item {
  display: flex;
  gap: 14px;
  padding: 18px 18px;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.06);
}

.feature-icon {
  width: 34px;
  height: 34px;
  border-radius: 999px;
  background: #dbeafe;
  color: #1d4ed8;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  flex: 0 0 34px;
}

.feature-item h3,
.adv-card h3,
.panel-card h3 {
  margin: 0 0 8px;
  font-size: 19px;
  color: #0f172a;
}

.feature-item p,
.adv-card p,
.panel-card p {
  margin: 0;
  line-height: 1.85;
  color: #475569;
}

.side-panel {
  position: sticky;
  top: 24px;
}

.panel-card {
  background: linear-gradient(180deg, #ffffff, #f8fbff);
  border-radius: 24px;
  padding: 26px;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.08);
}

.spec-list {
  list-style: none;
  margin: 16px 0 0;
  padding: 0;
}

.spec-list li {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 0;
  border-bottom: 1px dashed #dbe3ef;
}

.spec-list li:last-child {
  border-bottom: 0;
}

.spec-list span {
  color: #64748b;
}

.spec-list strong {
  color: #0f172a;
}

.adv-card {
  position: relative;
  overflow: hidden;
  background: #fff;
  border-radius: 24px;
  padding: 28px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.06);
}

.adv-number {
  font-size: 46px;
  font-weight: 900;
  line-height: 1;
  margin-bottom: 18px;
  color: rgba(37, 99, 235, 0.14);
}

.gallery-section p {
  color: #64748b;
  margin-top: 12px;
}

.showcase-grid {
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  gap: 18px;
  margin-top: 30px;
}

.showcase-image-main {
  min-height: 360px;
  padding: 14px;
}

.showcase-image-side {
  min-height: 360px;
  padding: 14px;
}

.showcase-video-wide {
  grid-column: 1 / -1;
  min-height: 420px;
  padding: 14px;
}

.rent-box {
  display: grid;
  grid-template-columns: 1.1fr .9fr;
  gap: 22px;
  align-items: center;
  background: linear-gradient(135deg, #0f172a, #1e3a8a);
  color: #fff;
  border-radius: 30px;
  padding: 34px;
  box-shadow: 0 24px 50px rgba(15, 23, 42, 0.16);
}

.rent-box h2,
.contact-card h2 {
  margin: 8px 0 12px;
  font-size: clamp(28px, 4vw, 40px);
}

.rent-box p,
.contact-card p {
  margin: 0;
  line-height: 1.9;
  color: rgba(255, 255, 255, 0.86);
}

.rent-cta {
  display: grid;
  gap: 14px;
  justify-items: start;
}

.contact-section {
  padding-top: 24px;
}

.contact-card {
  display: grid;
  grid-template-columns: 1.2fr .8fr;
  gap: 22px;
  background: linear-gradient(180deg, #ffffff, #f8fbff);
  border-radius: 30px;
  padding: 34px;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.08);
}

.contact-card p {
  color: #475569;
}

.contact-side {
  background: #f8fafc;
  border-radius: 24px;
  padding: 24px;
  display: grid;
  align-content: center;
  gap: 14px;
}

.contact-phone {
  font-size: clamp(28px, 4vw, 42px);
  font-weight: 900;
  color: #0f172a;
}

.contact-address {
  color: #64748b;
  line-height: 1.7;
}

.footer {
  padding: 26px 0 100px;
  background: #0b1220;
  color: rgba(255, 255, 255, 0.8);
}

.footer-inner {
  display: flex;
  justify-content: space-between;
  gap: 18px;
  align-items: center;
}

.footer p {
  margin: 8px 0 0;
  color: rgba(255, 255, 255, 0.66);
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.86);
}

.mobile-call {
  position: fixed;
  left: 16px;
  right: 16px;
  bottom: 16px;
  z-index: 30;
  min-height: 54px;
  border-radius: 999px;
  display: none;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  color: #fff;
  font-weight: 800;
  box-shadow: 0 16px 34px rgba(37, 99, 235, 0.28);
}

@media (max-width: 1024px) {

  .grid-4,
  .grid-3 {
    grid-template-columns: 1fr 1fr;
  }

  .intro-media-grid,
  .two-col,
  .rent-box,
  .contact-card,
  .showcase-grid {
    grid-template-columns: 1fr;
  }

  .showcase-video-wide {
    grid-column: auto;
  }

  .side-panel {
    position: static;
  }
}

@media (max-width: 768px) {
  .section {
    padding: 56px 0;
  }

  .container {
    width: min(100% - 24px, 1180px);
  }

  .hero {
    min-height: auto;
  }

  .hero-content {
    padding: 72px 0 82px;
  }

  .quick-info {
    margin-top: -36px;
  }

  .grid-4,
  .grid-3 {
    grid-template-columns: 1fr;
  }

  .panoramic-card,
  .video-card,
  .showcase-image-main,
  .showcase-image-side,
  .showcase-video-wide {
    min-height: auto;
  }

  .info-card,
  .panel-card,
  .adv-card,
  .contact-side,
  .media-card,
  .showcase-card,
  .card-surface {
    border-radius: 20px;
  }

  .hero-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .btn,
  .btn-lg {
    width: 100%;
  }

  .footer-inner {
    flex-direction: column;
    align-items: flex-start;
  }

  .mobile-call {
    display: flex;
  }

  .footer {
    padding-bottom: 92px;
  }
}
</style>
